export default {
  openapi: "3.0.0",

  servers: [
    {
      description: "mea API",
      url: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}`,
    },
  ],
  tags: [
    {
      name: "SCS Public",
    },
    {
      name: "SCS Private",
    },
  ],
  paths: {
    "/embed/scs-public": {
      get: {
        tags: ["SCS Public"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "ดึง SCS Public",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `API Key ของคุณ`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "search",
            description: "ค้นหา",
            schema: {
              type: "string",
              example: "วัดท่า",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 3,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
              // example: 1,
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      _id: {
                        type: "string",
                      },
                      location: {
                        type: "string",
                      },   
                      road_name: {
                        type: "string",
                      },                                         
                      lat: {
                        type: "number",
                        format: "double",
                      },
                      lon: {
                        type: "number",
                        format: "double",
                      },
                      keyword: {
                        type: "string",
                      }
                    },
                  },
                },
                example: [
                  {
                      "_id": 1176,
                      "location": "วัดท่าเกวียน",
                      "road_name": "ถนนวัดท่าเกวียน",
                      "lat": 13.96497863,
                      "lon": 100.45724254,
                      "keyword": "วัดท่าเกวียน ถนนวัดท่าเกวียน"
                  },
                  {
                      "_id": 4127,
                      "location": "วัดท่าอิฐ",
                      "road_name": "ซอยบ้านสวน",
                      "lat": 13.899741,
                      "lon": 100.48077677,
                      "keyword": "วัดท่าอิฐ ซอยบ้านสวน"
                  },
                  {
                      "_id": 12984,
                      "location": "วัดท่าพระ",
                      "road_name": "ซอยจรัญสนิทวงศ์ 4",
                      "lat": 13.73413087,
                      "lon": 100.47331083,
                      "keyword": "วัดท่าพระ ซอยจรัญสนิทวงศ์ 4"
                  }
                ]
              },
            },
          },
        },
      },
    },
    "/embed/scs-public/data": {
      get: {
        tags: ["SCS Public"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "ดึง SCS Public ด้วยพิกัด ละติจูด ลองจิจูด",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `API Key ของคุณ`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            required: true,
            name: "latitude",
            description: `ละติจูด`,
            schema: {
              type: "number",
              format :"double",
              example: 13.899741,
            }
          },
          {
            in: "query",
            required: true,
            name: "longitude",
            description: `ลองจิจูด`,
            schema: {
              type: "number",
              format :"double",
              example: 100.48077677,
            }          
        }
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {

                  type: "object",
                  properties: {
                    nearby_meter: {
                      type: "string",
                    },
                    soi: {
                      type: "string",
                    },
                    street: {
                      type: "string",
                    },
                    street: {
                      type: "string",
                    },                      
                    moo_village: {
                      type: "string",
                    },
                    postcode: {
                      type: "string",
                    },  
                    distance: {
                      type: "integer",
                    },     
                    mea_district_name: {
                      type: "string",
                    },
                    mea_district_namt: {
                      type: "string",
                    },   
                    mea_district_code: {
                      type: "integer",
                    },      
                    amp_name: {
                      type: "string",
                    },                                                                                                
                    tam_namet: {
                      type: "string",
                    },
                    amp_name: {
                      type: "string",
                    },                      
                    amp_namet: {
                      type: "string",
                    },
                    prov_name: {
                      type: "string",
                    },
                    prov_namet: {
                      type: "string",
                    },
                    lat: {
                      type: "number",
                      format: "double",
                    },
                    lon: {
                      type: "number",
                      format: "double",
                    }
                  },

                },
                example: {
                  "nearby_meter": "0093078763",
                  "soi": "ซ.ท่าอิฐ",
                  "street": "ถ.ท่าอิฐ",
                  "moo_village": "ม.6",
                  "postcode": "11120",
                  "distance": 42.052557532079405,
                  "mea_district_name": "Bang Yai District",
                  "mea_district_namt": "การไฟฟ้าเขตบางใหญ่",
                  "mea_district_code": "59",
                  "tam_name": "THA IT",
                  "tam_namt": "ท่าอิฐ",
                  "amp_name": "PAK KRET",
                  "amp_namt": "ปากเกร็ด",
                  "prov_name": "NONTHABURI",
                  "prov_namt": "นนทบุรี",
                  "lat": 13.899741,
                  "lon": 100.48077677
                }
              },
            },
          },
        },
      },
    },
    "/embed/scs-private": {
      get: {
        tags: ["SCS Private"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "ดึง SCS Private",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `API Key ของคุณ`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "search",
            description: "ค้นหา",
            schema: {
              type: "string",
              example: "วัดท่า",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
              // example: 1,
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      _id: {
                        type: "string",
                      },
                      u_inst: {
                        type: "string",
                      }, 
                      tariff: {
                        type: "string",
                      },  
                      mru: {
                        type: "string",
                      }, 
                      title: {
                        type: "string",
                      },  
                      name: {
                        type: "string",
                      }, 
                      sur_name: {
                        type: "string",
                      },   
                      house_no: {
                        type: "string",
                      },   
                      moo_village: {
                        type: "string",
                      },  
                      floor: {
                        type: "string",
                      }, 
                      soi: {
                        type: "string",
                      }, 
                      street: {
                        type: "string",
                      }, 
                      sub_distinct: {
                        type: "string",
                      },                                                                                                                                                   
                      district: {
                        type: "string",
                      },
                      province: {
                        type: "string",
                      }, 
                      postcode: {
                        type: "string",
                      },
                      lat: {
                        type: "number",
                        format: "double",
                      },
                      lon: {
                        type: "number",
                        format: "double",
                      },                                                                 
                      keyword: {
                        type: "string",
                      }

                    },
                  },
                },
                example: [
                  {
                      "_id": "0093091367",
                      "u_inst": "0093091367",
                      "tariff": "1.2",
                      "mru": "59930462",
                      "title": "วัด",
                      "name": "ท่าอิฐ",
                      "sur_name": "",
                      "house_no": "",
                      "moo_village": "เมรุ วัดท่าอิฐ",
                      "floor": "",
                      "soi": "",
                      "street": "ถ.วัดท่าอิฐ-วัดเชิงเลน",
                      "sub_distinct": "ต.ปากเกร็ด",
                      "district": "อ.ปากเกร็ด น",
                      "province": "",
                      "postcode": "11120",
                      "lat": 13.89887954,
                      "lon": 100.48029298,
                      "keyword": "ฟขญ.:93091367:- 1.2 MRU:59930462:วัดท่าอิฐ   เมรุ วัดท่าอิฐ   ถ.วัดท่าอิฐ-วัดเชิงเลน ต.ปากเกร็ด อ.ปากเกร็ด น  11120"
                  },
                  {
                      "_id": "0093018588",
                      "u_inst": "0093018588",
                      "tariff": "1.2",
                      "mru": "59930406",
                      "title": "วัด",
                      "name": "ท่าอิฐ",
                      "sur_name": "",
                      "house_no": "",
                      "moo_village": "วัดท่าอิฐ ริมแม่น้ำเจ้าพระยา",
                      "floor": "",
                      "soi": "",
                      "street": "",
                      "sub_distinct": "ต.ท่าอิฐ",
                      "district": "อ.ปากเกร็ด",
                      "province": "นนทบุรี",
                      "postcode": "11120",
                      "lat": 13.89987479,
                      "lon": 100.48126362,
                      "keyword": "ฟขญ.:93018588:- 1.2 MRU:59930406:วัดท่าอิฐ   วัดท่าอิฐ ริมแม่น้ำเจ้าพระยา    ต.ท่าอิฐ อ.ปากเกร็ด นนทบุรี 11120"
                  }
              ],
              },
            },
          },
        },
      },
    },
    "/embed/scs-private/data": {
      get: {
        tags: ["SCS Private"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "ดึง SCS Private ด้วยพิกัด ละติจูด ลองจิจูด",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `API Key ของคุณ`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            required: true,
            name: "latitude",
            description: `ละติจูด`,
            schema: {
              type: "number",
              format :"double",
              example: 13.899741,
            }
          },
          {
            in: "query",
            required: true,
            name: "longitude",
            description: `ลองจิจูด`,
            schema: {
              type: "number",
              format :"double",
              example: 100.48077677,
            }          
        }
      ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    nearby_meter: {
                      type: "string",
                    },                      
                    soi: {
                      type: "string",
                    },
                    street: {
                      type: "string",
                    },                                            
                    moo_village: {
                      type: "string",
                    },
                    postcode: {
                      type: "string",
                    }, 
                    distance: {
                      type: "number",                        
                    },   
                    mea_district_name: {
                      type: "string",
                    },
                    mea_district_namt: {
                      type: "string",
                    }, 
                    mea_district_code: {
                      type: "integer",
                    },                                                                                    
                    tam_name: {
                      type: "string",
                    },
                    tam_namt: {
                      type: "string",
                    },
                    amp_name: {
                      type: "string",
                    },
                    amp_namt: {
                      type: "string",
                    },
                    prov_name: {
                      type: "string",
                    },
                    prov_namt: {
                      type: "string",
                    },
                    lat: {
                      type: "number",
                      format: "double",
                    },
                    lon: {
                      type: "number",
                      format: "double",
                    }
                  },
     
                },
                example: {
                  "nearby_meter": "0093091367",
                  "soi": "",
                  "street": "ถ.วัดท่าอิฐ-วัดเชิงเลน",
                  "moo_village": "เมรุ วัดท่าอิฐ",
                  "postcode": "11120",
                  "distance": 0,
                  "mea_district_name": "Bang Yai District",
                  "mea_district_namt": "การไฟฟ้าเขตบางใหญ่",
                  "mea_district_code": "59",
                  "tam_name": "THA IT",
                  "tam_namt": "ท่าอิฐ",
                  "amp_name": "PAK KRET",
                  "amp_namt": "ปากเกร็ด",
                  "prov_name": "NONTHABURI",
                  "prov_namt": "นนทบุรี",
                  "lat": 13.89887954,
                  "lon": 100.48029298
              }
              },
            },
          },
        },
      },
    },
  },
  components: {
    securitySchemes: {
      ApiKeyAuth: {
        type: "apiKey",
        in: "query",
        name: "api_key",
        description: "API Key ของคุณ",
      },
    },
  },
};
